export const ru = {
    'status-disconnected': 'Вернуться в звонок',
    'status-active': 'Отключиться от звонка',
    'status-join': 'Присоединиться к звонку',
    'status-ended': 'Присоединиться к звонку',
    'reconnect-button': 'Вернуться',
    'disconnect-button': 'Отключиться',
    'join-button': 'Присоединиться',
};
